// ContactPage.js

import React, { useState } from 'react';
import './ContactPage.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you can implement the logic to send the email, either through an API call or other method.
    console.log('Form Data:', formData);
    alert('Message sent successfully!');
    setFormData({ name: '', email: '', message: '' });
  };

  return (
    <div>
    <br/>
    <br/>
    <br/>
    <br/>
    <h2>Privacy Policy</h2>
    <br/>
    <br/>
    <br/>
    <br/>
      
      <p>
        Mobile information will not be shared with third parties/affiliates for marketing/promotional
        purposes. All the above categories exclude text messaging originator opt-in data and consent;
        this information will not be shared with any third parties.
        <br></br>
        <br></br>
        If you wish to be removed from receiving future communications, you can opt out by
        texting STOP.
        <br></br>
        <br></br>
        By checking this box, I agree to receive text messages at the number provided from Saphire
        Properties regarding West Bridgewater Inn. Message frequency may vary.
        Message and data rates may apply. Text HELP for help and STOP to opt out. Privacy Policy and
        Mobile Terms of Service can be found here [Link].
        <br></br>
        <br></br>
        You can cancel the SMS service at any time. Just text STOP. After you send the SMS message
        STOP to us, we will send you an SMS message to confirm that you have been unsubscribed.
        After this, you will no longer receive SMS messages from us. If you want to join again, just sign
        up as you did the first time and we will start sending SMS messages to you again
        <br></br>
        <br></br>
        If you are experiencing issues with the messaging program you can reply with the keyword
        HELP for more assistance, or get help directly at support email address or contact number.)
        * Carriers are not liable for delayed or undelivered messages.
        * As always, message and data rates may apply for any messages sent to you from us and to us
        from you. Message frequency may vary. If you have any questions about your text plan or data
        plan, it is best to contact your wireless provider
        * If you have any questions regarding privacy, please read our privacy policy: <a style={{ color: 'blue' }} href='https://www.textrequest.com/privacy-policy'> Text Request Privacy Policy </a>
        <a style={{ color: 'blue' }} href='https://app-na1.hubspotdocuments.com/documents/6306809/view/1676393293?accessId=b15b17'>Privacy Policy + SMS Term Guide</a>
        
    </p>
    </div>
  );
};

export default Contact;
